import { AbstractControl, ValidatorFn } from '@angular/forms';

export function RegExArrayValidator( array: { title: string, regex: string }[] ): ValidatorFn {
   return ( control: AbstractControl ): { [key: string]: any } => {
      let response = [];

      array.forEach( expression => {
         if ( !new RegExp( expression.regex ).test( control.value )) {

            let responseObj = {
               title: expression.title,
               value: control.value
            };

            response.push( responseObj );
         }
      });
      return response.length > 0 ? response : null;
   };
}
